import React, { useEffect } from 'react';
import { useAppSelector } from '../../../store';
import { API_FINANCE } from '../../../api/finance';
import { useDispatch } from 'react-redux';
import {
  setDepositGates,
  setDepositPlayers,
  setDepositStatuses
} from '../../../store/apps/financeSlice';

export default function useGetDepositInfo({ groupId } = {}) {
  const dispatch = useDispatch();
  const gates = useAppSelector((state) => state.finance.deposit.gates);
  const statusHash = useAppSelector((state) => state.finance.deposit.statusHash);
  const players = useAppSelector((state) => state.finance.deposit.players);
  const playersGroup = players[groupId] || [];

  const gateLength = gates.length;
  const statusLength = Object.keys(statusHash).length;
  const playerLength = playersGroup?.length;

  const updateGates = () => {
    API_FINANCE.deposit
      .gates()
      .then((e) => {
        const list = e.data.list;
        dispatch(setDepositGates(list));
      })
      .catch(console.log);
  };

  const updateStatuses = () => {
    API_FINANCE.deposit
      .statuses()
      .then((e) => {
        const list = e.data.list;
        dispatch(setDepositStatuses(list));
      })
      .catch(console.log);
  };

  const updatePlayers = (groupId) => {
    if (!groupId) return;
    API_FINANCE.deposit
      .players({ groupId })
      .then((e) => {
        const list = e.data.list;
        dispatch(setDepositPlayers({ groupId, data: list }));
      })
      .catch(console.log);
  };

  useEffect(() => {
    if (!gateLength) {
      updateGates();
    }
    if (!statusLength) {
      updateStatuses();
    }
    if (!playerLength) {
      updatePlayers(groupId);
    }
  }, [groupId]);

  return { gates, statusHash, playersGroup, updateGates, updateStatuses, updatePlayers };
}
